'use strict';

import burgerMenu from './modules/burgerMenu';
import anchorLinks from './modules/anchorLinks';
import aos from './modules/aos.js';
import latestSlider from './modules/latestSlider.js';

document.addEventListener('DOMContentLoaded', () => {
    aos();
    anchorLinks();

    const header = document.querySelector('.header');

    window.addEventListener('scroll', () => {
        const headerHeight = header.offsetHeight;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        document.body.classList.toggle('fixed', scrollTop > headerHeight);
    }, { passive: true });

    document.querySelectorAll('.navbar__nav a').forEach(link => {
        link.addEventListener('click', () => {
            document.body.classList.remove('nav-active');
        });
    });
});
